import { render, staticRenderFns } from "./BLAttachPop.vue?vue&type=template&id=dd508978"
import script from "./BLAttachPop.vue?vue&type=script&lang=js"
export * from "./BLAttachPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd508978')) {
      api.createRecord('dd508978', component.options)
    } else {
      api.reload('dd508978', component.options)
    }
    module.hot.accept("./BLAttachPop.vue?vue&type=template&id=dd508978", function () {
      api.rerender('dd508978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/BLAttachPop.vue"
export default component.exports